(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ajax-cart-toast"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.__ajaxCartProductFeedbackInitialised) return;
  window.__ajaxCartProductFeedbackInitialised = true;

  var feedback = document.getElementById('AjaxCartFeedback');

  function updateCartBubble(itemCount) {
    document.querySelectorAll('.cart-link__bubble').forEach(function(bubble) {
      bubble.classList.toggle('cart-link__bubble--visible', itemCount > 0);
    });
  }

  document.addEventListener('submit', function(event) {
    var form = event.target;

    if (!form || !form.matches('form.product-single__form')) return;
    if (form.querySelector('[data-ajax-cart-skip]')) return;

    var button = event.submitter || form.querySelector('[data-add-to-cart]');
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var buttonText = button.querySelector('[data-add-to-cart-text]');
    var originalText = buttonText ? buttonText.textContent.trim() : 'Add to cart';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('ajax-cart-feedback-state');
    if (buttonText) buttonText.textContent = 'Adding...';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(form)
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function() {
        return fetch(root + 'cart.js', {
          headers: { 'Accept': 'application/json' }
        });
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        updateCartBubble(cart.item_count);

        if (buttonText) buttonText.textContent = 'Added!';
        if (feedback) feedback.textContent = 'Added to basket';

        window.setTimeout(function() {
          if (buttonText) buttonText.textContent = originalText;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.classList.remove('ajax-cart-feedback-state');
        }, 2000);
      })
      .catch(function(error) {
        var message = error && error.description ? error.description : 'Unable to add to basket';

        if (buttonText) buttonText.textContent = 'Error';
        if (feedback) feedback.textContent = message;

        window.setTimeout(function() {
          if (buttonText) buttonText.textContent = originalText;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }, 2000);
      });
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
